module.exports = __webpack_public_path__ + "static/media/desktop-down-icon.2470d302.svg";